import { Provider, observer } from 'mobx-react';
import React from 'react';

import ProntoCache from 'bz-pronto-core/cache';
import { cache } from 'tm3-core/cache';
import CacheStore from './stores/cache';
import MediatorStore from './stores/mediator';
import RegisterStore from './stores/register';

@observer
class Register extends React.Component {
  mediator: MediatorStore;

  constructor(props) {
    super(props);

    this.mediator = new MediatorStore();
  }

  render() {
    return (
      <Provider
        prontoCache={ProntoCache}
        register={cache.app.registerStore}
        mediator={this.mediator}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export default Register;
